export type AudioProperties = {
  duration?: number;
};

export const extractAudioProperties = async (url: string): Promise<AudioProperties> => {
  try {
    return await new Promise<AudioProperties>((resolve, reject) => {
      const audio = document.createElement("audio");
      audio.preload = "metadata";

      audio.onloadedmetadata = () => {
        resolve({ duration: audio.duration });
      };

      audio.onerror = (error) => {
        reject(error);
      };

      audio.src = url;
    });
  } catch (error) {
    console.warn("Failed to extract audio properties on upload", error);
  }

  return { duration: undefined };
};
